/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum BroadcastSkipReasonEnum {
  NotAddressable = 'not_addressable',
  NoActiveTeamMember = 'no_active_team_member'
}
